module.exports = __webpack_public_path__ + "img/store_UberEats.b375e66a.svg";